import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { RedirectService } from '../services/redirect.service';

export const homeRedirectGuard: CanActivateFn = route => {
  const redirectService = inject(RedirectService);
  return redirectService.redirectTo(['/'], { replaceUrl: true, queryParams: route.queryParams });
};
